import _classCallCheck from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import React, { PureComponent } from "react";
// Material imports
import { withStyles } from "@material-ui/core/styles"; // Limitless improts

import { withi18n } from "../hocs/i18n";

var ToolTip = /*#__PURE__*/function (_PureComponent) {
  _inherits(ToolTip, _PureComponent);

  var _super = _createSuper(ToolTip);

  function ToolTip() {
    _classCallCheck(this, ToolTip);

    return _super.apply(this, arguments);
  }

  _createClass(ToolTip, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          children = _this$props.children,
          t = _this$props.t,
          classes = _this$props.classes;
      return /*#__PURE__*/React.createElement("div", {
        "data-title": t(title),
        className: "".concat(classes.tooltip, " ").concat(classes.expand)
      }, children);
    }
  }]);

  return ToolTip;
}(PureComponent);

var styles = function styles(theme) {
  return {
    icon: {
      width: "0.9em"
    },
    tooltip: {
      "&:before, &:after": {
        display: "block",
        opacity: "0",
        pointerEvents: "none",
        position: "absolute"
      },
      "&:before": {
        backgroundColor: theme.palette.tooltip ? theme.palette.tooltip.backgroundColor : theme.palette.contrast.light,
        borderRadius: 4,
        color: theme.palette.tooltip ? theme.palette.tooltip.textColor : theme.palette.contrast.main,
        content: "attr(data-title)",
        fontSize: 13,
        fontFamily: theme.typography.fontFamily,
        padding: "8px 36px 8px 10px",
        right: 0,
        bottom: -12,
        width: 200,
        minHeight: 38,
        lineHeight: "1.1rem",
        display: "flex",
        flex: 1,
        alignItems: "center"
      }
    },
    expand: {
      "&:before": {
        transform: "scale3d(.2,.2,1)",
        transition: "all .2s ease-in-out"
      },
      "&:after": {
        transform: "translate3d(0,6px,0)",
        transition: "all .1s ease-in-out"
      },
      "&:hover:before, &:hover:after": {
        opacity: "1",
        transform: "scale3d(1,1,1)",
        zIndex: 1
      },
      "&:hover:after": {
        transition: "all .2s .1s ease-in-out"
      }
    }
  };
};

export default withStyles(styles)(withi18n(ToolTip));